<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col class="text-right col-200px" >

            <v-dialog
                ref="timeDialog"
                v-model="timeModal"
                :return-value.sync="currentDate"
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="currentDateFinal"
                    label="За число"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="currentDate"
                  full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="pickDate()"
                >
                  Ok
                </v-btn>
              </v-date-picker>
            </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет улиц"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="workshops"
              v-model="selected"
              :search="search"
              :fixed-header="true"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              height="60vh"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка улиц... Подождите пожалуйста"
      >

        <template v-slot:item="{item,index}">
          <tr class="grouped-row">
            <td>
              <template>
                <v-icon class="mr-2" v-if="item.show" @click="item.show = false">mdi-chevron-up</v-icon>
                <v-icon class="mr-2" v-else @click="item.show = true">mdi-chevron-down</v-icon>
              </template>
              {{ item.name }}
            </td>
            <td></td>
          </tr>
          <template>
            <tr v-for="branch in branches" v-if="item.show" :class="{'changed-row': isChangedRow(item, branch)}" :key="item.id + '_' + branch.id">
              <td class="pl-13">{{ branch.name }}</td>
              <td>
                <span v-for="delivery in deliveryTimes" :class="'delivery-item ' + (picked[ branch.id + '_' + item.id + '_' + delivery.name.split(':').map(item => +item).join('_')] ? 'active' : '')" @click="changeBusy( branch.id + '_' + item.id + '_'  + delivery.name.split(':').map(item => +item).join('_'))">
                    {{delivery.name}}
                </span>
              </td>
            </tr>
          </template>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import WorkshopService from '../../../api/WorkshopService'
    import BranchService from "../../../api/BranchService";
    import AreaService from "../../../api/AreaService";
    import moment from 'moment'
    import OrderService from "@/api/OrderService";

    export default {
        name: 'WorkshopsBusy',
        components: {},
        data: () => ({
            timeModal: false,
            currentDate: (new Date()).toISOString().split('T')[0],
            currentDateFinal: (new Date()).toISOString().split('T')[0],
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            selected: [],
            submitDialog: false,
            submitItem: null,
            workshops: [],
            branches: [],
            picked: {},
            deliveryTimes: [],
            options: {},
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Группа',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Доступное время',
                    value: 'area.name',
                    sortable: false
                },
            ],
        }),
        mounted() {
          BranchService.list().then(response => {
            this.branches = response.data;
          })

          this.loadTimes();
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          loadTimes() {

            OrderService.getDeliveryTimeList({date: this.currentDateFinal}).then(response => {

              const { times, picked } = response.data;

              this.deliveryTimes = times;
              this.picked = picked;
            });
          },
          changeBusy(key) {
            this.picked[key] = !this.picked[key];

            const data = key.split('_');
            OrderService.toggleDeliveryTime({
              branch_id: data[0],
              workshop_id:  data[1],
              hours:  +data[2],
              minutes: +data[3],
              date: this.currentDateFinal,
            });

            this.$forceUpdate();
          },
          submitDelete(item = null){
            if(item){
              this.removeWorkshop(item)
            } else {
              //this.massDelete()
            }
          },
          pickDate() {
            this.timeModal = false;
            const date = this.currentDate;

            this.currentDateFinal = date;
            this.loadTimes();
          },
          getTime(time){
            return moment('2020-01-01 ' + time).format('HH:mm')
          },
            isChangedRow(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              if(branchWorkshop.delivery_time == item.default_delivery_time){
                return false;
              }
              return true;
            },
            getBranchWorkshop(item, branch){
                if(item.data.find(branchWorkshop => branchWorkshop.id == branch.id)){
                  return item.data.find(branchWorkshop => branchWorkshop.id == branch.id);
                }

                item.data.push({
                  delivery_time: item.default_delivery_time ,
                  id: branch.id
                })

                return item.data.find(branchWorkshop => branchWorkshop.id == branch.id);
            },
            resetTime(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.delivery_time = item.default_delivery_time

              WorkshopService.update({
                id: item.id,
                data: item.data,
              }).then(response => {
              })
            },
            changeTime(item, branch, time){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.delivery_time = moment('2020-01-01 ' + branchWorkshop.delivery_time).add(time, 'm').format('HH:mm:ss')

              WorkshopService.update({
                id: item.id,
                data: item.data
              }).then(response => {

              })
            },
            toggleDisabled(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.is_disabled = branchWorkshop.is_disabled ? false : true;

              WorkshopService.update({
                id: item.id,
                data: item.data
              }).then(response => {

              })
            },
            removeWorkshop(item){
              WorkshopService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getDataFromApi() {
                this.loading = true

                WorkshopService.list({})
                    .then(response => {
                        this.workshops = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .grouped-row td:first-child {
    font-weight: bold;
    font-size: 16px !important;
    font-family: Consolas, sans-serif;
    letter-spacing: 1px;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }

  td:first-child {
    width: 30%;
  }

  table .v-input {
    height: auto !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    width: 120px;
  }

  .delivery-item {
    padding: 2px 5px;
    background-color: #ccc;
    color: #333;
    font-weight: bold;
    font-size: 12px;
    margin-right: 10px;
    display: inline-block;
    cursor: pointer;
    margin-bottom: 4px;
    user-select: none;

    &.active {
      background-color: #fcc;
    }
  }

  .col-200px {
    width: 200px;
    flex: 0 0 200px;
  }
</style>
